import topic from '../topic'
export const userAPI = {
    userLogin: topic.userTopic + '/login',
    userLogout: topic.userTopic + '/logout',
}